import { render, staticRenderFns } from "./ProfitabilityCategoryEvolution.vue?vue&type=template&id=408eb164&scoped=true"
import script from "./ProfitabilityCategoryEvolution.vue?vue&type=script&lang=js"
export * from "./ProfitabilityCategoryEvolution.vue?vue&type=script&lang=js"
import style0 from "./ProfitabilityCategoryEvolution.vue?vue&type=style&index=0&id=408eb164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408eb164",
  null
  
)

export default component.exports